import React from "react";

import MessageModal from "../../../../components/HexModal/MessageModal";
import { getLabel } from "../../../../hooks/use-labels";

import { getConfig } from "../../../../hooks/use-config";
import "./style.css";

const CartLimitModal = ({ onClose }) => {
  const MAX_PRODUCTS = +getConfig("maxCartItems");
  const limitError = getLabel("cartLimitErrorMessage");
  return (
    <MessageModal
      open={true}
      title={getLabel("cartLimitLabel")}
      text={limitError.replace("{{}}", MAX_PRODUCTS)}
      onOkay={onClose}
      className={"cart-limit-modal"}
    />
  );
};

export default CartLimitModal;
